<template>
	<div class="index">
		<indexHeader></indexHeader>
	</div>
</template>

<script>
	import indexHeader from "../components/indexHeader";

	export default{
		name: 'index',
		components:{
			indexHeader
		}
	}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/index.vue